import { UserCenterBlock } from '@lighthouse/block/src/blocks'
import type { UserCenterBlockAbstract } from '@lighthouse/core'
import { DEVELOPER, useAtomAction } from '@lighthouse/shared'
import React from 'react'

import { appRoleAtom, AppSystemPageAtom } from '@/atoms/application/state'
import { useAppUser } from '@/hooks/useUserPageList'

interface UserCenterBlockProps {
    blockData: UserCenterBlockAbstract
}

const UserCenterBlockController: React.FC<UserCenterBlockProps> = ({ blockData }) => {
    const user = useAppUser()

    const { run: setAppSystemPage } = useAtomAction(AppSystemPageAtom)
    const { run: setAppRole } = useAtomAction(appRoleAtom)

    return (
        <UserCenterBlock
            blockData={blockData}
            user={user}
            onLogout={() => {
                setAppRole(DEVELOPER)
            }}
            onLogin={() => {
                setAppSystemPage('LOGIN')
            }}
        />
    )
}

export default UserCenterBlockController
